import { useMemo, useState } from 'react'
import { HeaderWapper, Heading, Wapper } from '../style'
import Switch from '../Switch'
import { monthNames } from '../../SalesDashboard'
import BarCharts from '../BarChart'
import { LightTheme } from '@styles'

export const prepareChartData = (data = [], keys = []) => {
	if (!Array.isArray(data)) return []

	return data
		.map((item) => {
			const formatted = {
				month: `${monthNames[item.month - 1]} ${item.year}`,
			}
			keys.forEach((k) => {
				formatted[k] = item[k] || 0
			})
			return formatted
		})
		.sort((a, b) => {
			const [aMonth, aYear] = a.month.split(' ')
			const [bMonth, bYear] = b.month.split(' ')
			const monthIndex = (m) => monthNames.indexOf(m)
			if (aYear === bYear) return monthIndex(aMonth) - monthIndex(bMonth)
			return parseInt(aYear) - parseInt(bYear)
		})
}

export default function MonthlyPerformance({ MonthlyPerformanceData }) {
	const [status, setStatus] = useState('REVENUE')

	const chartData = useMemo(() => prepareChartData(MonthlyPerformanceData, ['amount', 'payment_amount', 'credit_amount']), [MonthlyPerformanceData])

	if (!chartData.length) return '-'
	
	return (
		<Wapper>
			<HeaderWapper>
				<Heading>Monthly Performance</Heading>
				{/* <Switch
					options={[
						{ label: 'Revenue', value: 'REVENUE' },
						// { label: 'Gm', value: 'GM' },
					]}
					value={status}
					onChange={setStatus}
				/> */}
			</HeaderWapper>
			<BarCharts
				data={chartData}
				dataKeys={['amount', 'payment_amount', 'credit_amount']}
				colors={[LightTheme.palette.background.blueTwo, LightTheme.palette.text.green, LightTheme.palette.text.red]}
				ToolTipUnit={'Cr'}
			/>
		</Wapper>
	)
}
